/**
 * Yaxle theme — the single Chakra theme for partbay-website.
 *
 * Assembles brand tokens, semantic tokens, the type scale, and component
 * recipes. This replaces the old minimal `src/theme.ts` (which now re-exports
 * this module as a backwards-compatible shim).
 */
import { extendTheme, type ThemeConfig } from '@chakra-ui/react';
import {
	colors,
	space,
	sizes,
	breakpoints,
	radii,
	shadows,
	zIndices,
	fonts,
	fontSizes,
	fontWeights,
	lineHeights,
	letterSpacings,
} from './tokens';
import { semanticTokens } from './semanticTokens';
import { textStyles } from './textStyles';
import { components } from './components';

const config: ThemeConfig = {
	initialColorMode: 'light',
	useSystemColorMode: false,
};

export const theme = extendTheme({
	config,
	colors,
	semanticTokens,
	space,
	sizes,
	breakpoints,
	radii,
	shadows,
	zIndices,
	fonts,
	fontSizes,
	fontWeights,
	lineHeights,
	letterSpacings,
	textStyles,
	components,
	styles: {
		global: {
			'html, body': {
				fontFamily: 'body',
			},
			body: {
				bg: 'bg.canvas',
				color: 'fg.default',
			},
		},
	},
});

export default theme;

export * from './tokens';
export { semanticTokens } from './semanticTokens';
export { textStyles } from './textStyles';
